export default __webpack_public_path__ + "static/media/path-of-brew-banner.27f8bae3.png";